import { Tag } from 'antd'

import { ConsultationStatus } from 'src/api/requests'
import { useLocales } from 'src/locales'

type Props = {
  status?: ConsultationStatus
}

const ConsultationStatusMap = {
  [ConsultationStatus.ABSENT]: 'error',
  [ConsultationStatus.PRESENT]: 'success',
  [ConsultationStatus.SCHEDULED]: 'warning'
}

export const ConsultationStatusTag = ({ status }: Props) => {
  const { t } = useLocales()

  if (!status) return '-'

  const color = ConsultationStatusMap[status]

  return <Tag color={color}>{t(`consultations.personStatus.${status}`)}</Tag>
}
